export default function useQueryFlags() {
  const { getQueryParam } = useRouting();

  return {
    immediateSessionRecording: !!getQueryParam('immediate_session_recording'),
  };
}